module.exports = __webpack_public_path__ + "img/source.97795670.gif";